<template>
  <v-layout
    v-if="!isSheetDecisionLoading"
    id="content-area"
    column
    py-3
    fill-height
  >
    <v-flex class="question">
      <p class="required-block_left">
        {{ $t('sheet.fields_required') }}
      </p>
      <ul class="questions-list">
        <li
          v-if="getDecisionQuestions.hasOwnProperty('is_turn_on')"
          class="mt-4"
        >
          <p
            class="header mb-0"
            :class="{ required: getDecisionQuestions.is_turn_on.required }"
          >
            {{ getDecisionQuestions.is_turn_on.label }}
          </p>
          <p class="fw-400 f-1">
            {{ $t('sheet.sheetOne.decision.question_1_hint') }}
          </p>
          <ConfirmButtons
            :key="'isTurnOn'"
            v-model="isTurnOn"
            v-validate="{ required: getDecisionQuestions.is_turn_on.required }"
            string
            class="mb-4"
            :error-messages="errors.collect('isTurnOn')"
            :data-vv-as="$t('label.question')"
            :data-vv-name="'isTurnOn'"
            :disabled="readOnly"
          />
        </li>
        <li
          v-if="getDecisionQuestions.hasOwnProperty('help_criteria') && isTurnOn === 'yes'"
          class="mt-4"
        >
          <p
            class="header"
            :class="{ required: getDecisionQuestions.help_criteria.required }"
          >
            {{ getDecisionQuestions.help_criteria.label }}
          </p>
          <SelectableList
            :key="'tmpHelpCriteria'"
            v-model="tmpHelpCriteria"
            v-validate="{ required: getDecisionQuestions.help_criteria.required }"
            :items="getHelpCriteria"
            :error-messages="errors.collect('helpCriteria')"
            :data-vv-as="$t('label.question')"
            :data-vv-name="'helpCriteria'"
            :disabled="readOnly"
          />
        </li>
        <li
          v-if="
            getDecisionQuestions.hasOwnProperty('why_include_again') &&
              isTurnOn === 'yes' &&
              helpReceived === 'yes'
          "
          class="mt-4"
        >
          <p
            class="header mb-0"
            :class="{ required: getDecisionQuestions.why_include_again.required }"
          >
            {{ getDecisionQuestions.why_include_again.label }}
          </p>
          <p class="fw-400 f-1">
            {{ $t('sheet.sheetOne.decision.turnOn.question_3_hint') }}
          </p>
          <v-textarea
            :key="'whyIncludeAgain'"
            v-model="whyIncludeAgain"
            v-validate="{ ...regularLongText(getDecisionQuestions.why_include_again.required) }"
            :placeholder="$t('placeholders.add_text')"
            :required="getDecisionQuestions.why_include_again.required"
            :error-messages="errors.collect('decision_turn_on')"
            :data-vv-as="$t('label.question')"
            data-vv-name="decision_turn_on"
            auto-grow
            :disabled="readOnly"
          />
        </li>
        <li
          v-if="getDecisionQuestions.hasOwnProperty('non_inclusion') && isTurnOn === 'no'"
          class="mt-4"
        >
          <p
            class="header"
            :class="{ required: getDecisionQuestions.non_inclusion.reason.required }"
          >
            {{ getDecisionQuestions.non_inclusion.reason.label }}
          </p>
          <v-checkbox
            v-for="(item, index) in nonInclusionReasons"
            :key="index"
            v-model="reason"
            v-validate="{ required: getDecisionQuestions.non_inclusion.reason.required }"
            multiple
            :label="item.name"
            :value="item.id"
            :error="errors.has('nonInclusionReasons')"
            :error-messages="
              index + 1 === nonInclusionReasons.length
                ? errors.collect('nonInclusionReasons')
                : null
            "
            :data-vv-as="$t('label.question')"
            :data-vv-name="'nonInclusionReasons'"
            :disabled="readOnly"
          />
          <div v-if="getDecisionQuestions.hasOwnProperty('non_inclusion') && showOtherReason">
            <p
              class="fw-600 mt-3"
              :class="{ required: getDecisionQuestions.non_inclusion.other_reason.required }"
            >
              {{ getDecisionQuestions.non_inclusion.other_reason.label }}
            </p>
            <v-text-field
              :key="'otherReason'"
              v-model="otherReason"
              v-validate="{
                ...regularLongText(getDecisionQuestions.non_inclusion.other_reason.required)
              }"
              :placeholder="$t('placeholders.add_text')"
              :error-messages="errors.collect('decision_non_inclusion')"
              :data-vv-as="$t('label.question')"
              :data-vv-name="'decision_non_inclusion'"
              :required="getDecisionQuestions.non_inclusion.other_reason.required"
              class="pt-0 mt-0"
              :disabled="readOnly"
            />
          </div>
        </li>
        <li
          v-if="getDecisionQuestions.hasOwnProperty('non_inclusion') && isTurnOn === 'no'"
          class="mt-4"
        >
          <p
            class="header"
            :class="{ required: getDecisionQuestions.non_inclusion.explanation.required }"
          >
            {{ getDecisionQuestions.non_inclusion.explanation.label }}
          </p>
          <v-textarea
            :key="'decisionReason'"
            v-model="explanation"
            v-validate="{
              ...regularLongText(getDecisionQuestions.non_inclusion.explanation.required)
            }"
            :placeholder="$t('placeholders.add_text')"
            :error-messages="errors.collect('decision_non_inclusion_2')"
            :data-vv-as="$t('label.question')"
            data-vv-name="decision_non_inclusion_2"
            auto-grow
            :disabled="readOnly"
          />
        </li>
        <li
          v-if="getDecisionQuestions.hasOwnProperty('special_including') && isTurnOn != null"
          class="mt-4"
        >
          <p
            class="header mb-1"
            :class="{ required: getDecisionQuestions.special_including.required }"
          >
            {{ getDecisionQuestions.special_including.label }}
          </p>
          <p
            v-for="(text, index) in getDecisionQuestions.special_including.text"
            :key="index"
            class="fw-400 f-1 mb-1"
          >
            {{ text }}
          </p>
          <ConfirmButtons
            :key="'specialIncluding'"
            v-model="specialIncluding"
            v-validate="{ required: getDecisionQuestions.special_including.required }"
            string
            class="mt-3"
            :error-messages="errors.collect('specialIncluding')"
            :data-vv-as="$t('label.question')"
            :data-vv-name="'specialIncluding'"
            :disabled="readOnly"
          />
        </li>
        <li
          v-if="
            getDecisionQuestions.hasOwnProperty('include_to_special_projects') &&
              specialIncluding === 'yes'
          "
          class="mt-4"
        >
          <p
            class="header custom lA"
            :class="{ required: getDecisionQuestions.include_to_special_projects.required }"
          >
            {{ getDecisionQuestions.include_to_special_projects.label }}
          </p>
          <v-checkbox
            v-for="(item, index) in specialProjects"
            :key="index"
            v-model="includeToSpecialProjects"
            v-validate="{ required: getDecisionQuestions.include_to_special_projects.required }"
            multiple
            :label="item.description"
            :value="item.id"
            :error="errors.has('includeToSpecialProjects')"
            :error-messages="
              index + 1 === specialProjects.length
                ? errors.collect('includeToSpecialProjects')
                : null
            "
            :data-vv-as="$t('label.question')"
            :data-vv-name="'includeToSpecialProjects'"
            :disabled="readOnly"
          />
        </li>
      </ul>
    </v-flex>
    <SheetEndButtons
      :sheet-type="'decision'"
      :family-id="$route.params.familyId"
      :to="nextSectionId"
      :next-section-name="nextSectionName"
      :read-only="readOnly"
      :can-do-audit-in-area="canDoAuditInArea"
      :can-do-audit-on-national="canDoAuditOnNational"
      :national-correcting-permission="hasPermissionsForNationalCorrecting"
    />
    <leaveConfirmDialog ref="confirm" />
    <FamilyAudit
      v-if="showAuditCard"
      :can-add-comment="canAddComment"
      :family-id="$route.params.familyId"
      :sheet-type="'decision'"
      :comment-level="commentLevel"
      :has-permissions-to-add-comment="hasPermissionsToAddComment"
    />
  </v-layout>
  <PageLoader v-else />
</template>

<script>
import ConfirmButtons from '@/components/widgets/sheet/ConfirmButtons';
import SelectableList from '@/components/widgets/SelectableList';
import SheetEndButtons from '@/components/widgets/sheet/sheetEndButtons';
import leaveConfirmDialog from '@/components/widgets/LeaveConfirmDialog';
import FamilyAudit from '@/components/audit/FamilyAudit';

import validationRules from '@/constants/validationRules';
import permissions from '@/constants/permissions';

import { createHelpers } from 'vuex-map-fields';
import { mapGetters } from 'vuex';

import sheetResourcesGetter from '@/mixins/sheet/sheetResourcesGetter';
import sheetValidationRules from '@/mixins/sheet/sheetValidationRules';

import sheetBeforeLeave from '@/mixins/sheetBeforeLeave';
import auditPermissionsAndStatuses from '@/mixins/auditPermissionsAndStatuses';
import endButtonsCondition from '@/mixins/endButtonsCondition';
import isFamilyChecked from '@/mixins/sheet/isFamilyChecked';
import PageLoader from '@/components/widgets/PageLoader';
import postMeetingConsent from '@/constants/sheet/postMeetingConsent';

const { mapFields } = createHelpers({
    getterType: 'sheet/getDecision',
    mutationType: 'sheet/updateDecision'
});

const { mapFields: decisionTurnOn } = createHelpers({
    getterType: 'sheet/getDecisionTurnOn',
    mutationType: 'sheet/updateDecisionTurnOn'
});

const { mapFields: decisionNonInclusion } = createHelpers({
    getterType: 'sheet/getDecisionNonInclusion',
    mutationType: 'sheet/updateDecisionNonInclusion'
});

const { mapFields: previousEditions } = createHelpers({
    getterType: 'sheet/getPreviousEditionsField'
});

export default {
    name: 'SheetDecision',
    components: {
        PageLoader,
        ConfirmButtons,
        SelectableList,
        SheetEndButtons,
        leaveConfirmDialog,
        FamilyAudit
    },
    mixins: [
        sheetBeforeLeave,
        auditPermissionsAndStatuses,
        endButtonsCondition,
        sheetValidationRules,
        sheetResourcesGetter,
        isFamilyChecked,
        postMeetingConsent
    ],
    $_veeValidate: {
        validator: 'new'
    },
    beforeRouteEnter (to, from, next) {
        next((vm) => {
            const family = vm.$store.getters['family/getFamily'];
            if (
                (!from.name || from.name === 'family-card' || from.name === 'sheet-two') &&
        family?.sheets
            ) {
                const meetingSheet = family.sheets.find((sheet) => sheet.sheet_type === 'meeting');
                if (meetingSheet) {
                    vm.$store.commit('sheet/setSheetOne', { meeting: meetingSheet.sheet_data });
                }
            }

            vm.$store.dispatch('sheet/getSheetPermissions', vm.$route.params.familyId);
            vm.$store.dispatch('sheet/getExclusionReasons');
            vm.$store
                .dispatch('sheet/loadSheet', { familyId: vm.$route.params.familyId, sheetType: 'decision' })
                .finally(() => {
                    vm.tmpHelpCriteria = vm.getHelpCriteria.filter((item) => {
                        return vm.helpCriteria.includes(item.support_criterion_id);
                    });
                    vm.isSheetDecisionLoading = false;
                });
        });
    },
    data () {
        return {
            validationRules,
            permissions,
            isSheetDecisionLoading: true,
            tmpHelpCriteria: null
        };
    },
    computed: {
        ...mapGetters('sheet', ['getDecisionQuestions']),
        getHelpCriteria () {
            return this.$store.getters['sheet/getSheetOneResource'].support_criteria;
        },
        specialProjects () {
            return this.getResources(this.getDecisionQuestions.include_to_special_projects);
        },
        nonInclusionReasons () {
            return this.$store.getters['sheet/getExclusionReasons'];
        },
        ...mapFields(['isTurnOn', 'specialIncluding', 'includeToSpecialProjects']),
        ...decisionTurnOn(['helpCriteria', 'whyIncludeAgain']),
        ...decisionNonInclusion(['reason', 'otherReason', 'explanation']),
        ...previousEditions(['helpReceived']),
        showOtherReason () {
            return this.reason.includes(4);
        },
        sheetPermissions () {
            return this.$store.getters['sheet/getSheetPermissions'];
        },
        isCurrentEdition () {
            return this.$store.getters['family/isCurrentEdition'];
        },
        readOnly () {
            if (
                !this.canEditSheets ||
        (this.isFamilyVerifiedOnNational && !this.hasPermissionsForNationalCorrecting) ||
        !this.isCurrentEdition ||
        !this.isFamilyChecked
            ) {
                return true;
            }
            return !this.sheetPermissions.decision;
        },
        nextSectionName () {
            return this.isSheetReturned || this.canDoAuditInArea || this.canDoAuditOnNational
                ? 'Arkusza 2'
                : 'Karty Rodziny';
        },
        nextSectionId () {
            return this.isSheetReturned || this.canDoAuditInArea || this.canDoAuditOnNational
                ? 'sheet-two'
                : 'family-card';
        }
    },
    watch: {
        helpCriteria () {
            this.$validator.errors.remove('helpCriteria');
        },
        tmpHelpCriteria (val) {
            this.helpCriteria = Array.from(val, (x) => x.support_criterion_id);
        },
        specialIncluding (val) {
            if (val === 'no') {
                this.$nextTick(() => {
                    this.includeToSpecialProjects = [];
                });
            }
        },
        isTurnOn (val, valO) {
            if (valO == null) return;

            if (val === 'yes') {
                this.$nextTick(() => {
                    this.reason = [];
                    this.explanation = null;
                });
            } else {
                this.$nextTick(() => {
                    this.tmpHelpCriteria = [];
                    this.whyIncludeAgain = null;
                });
            }
        }
    }
};
</script>

<style scoped></style>
